<template lang='pug'>
  include ../../../../pug/mixins/bem
  controller.relative(
    :localsearch='search'
  )
    template(#inputview='{ keydownEvent, keyupEvent, model, goToSearch, activated, show, activeSearch }')
      .relative.search-form
        //- transition(name='fade')
        +b.circle-btn--mini.--circle.A(
          href='',
          :class='{"is-hidden": show}'
          @click.prevent='activeSearch'
        ).svgicon-search
        transition
          +b.search-input(
            v-if='show'
            :class="activated ? 'appearance_halfcircle' : 'appearance_circle' "
          )
            input-group(
              type='search',
              :placeholder='_("Введіть запит або слово для пошуку ")',
              v-model.trim='search',
              @keydown='keydownEvent'
              autocomplete='nddddo'
              :autofocus='true'
              ref='search-input'
              id='inputsearch'
              @keyup="keyupEvent",
            )
            +e.close.A(
              href='',
              @click.prevent='activeSearch'
            ) &times;
        
</template>
<script>
import { mapState } from 'vuex'
import Controller from './Controller'
import InputGroup from "./../CustomInputGroup"

export default {
  name: 'SearchView',
  props: ['className', 'fieldId', 'url'],
  components: {
    Controller,
    InputGroup,
  },
  watch: {
    global_search(nval) {
      this.search = nval
    }
  },
  
  data() {
    return {
      search: '',
      
    }
  },
  computed: {
    ...mapState('search', [
      'global_search'
    ])
  },

  mounted() {
    this.$store.subscribe((mutation, state) => {
      if ('search/SET_SEARCH' == mutation.type ) { 
        this.search = mutation.payload
      }
    })
  },
  methods: {
  },
}

</script>



// WEBPACK FOOTER //
// src/js/shared/components/search/View.vue